import { Box, Card, CardActionArea, CardContent, CardMedia, CircularProgress, Grid, Typography } from '@material-ui/core';
import { CloudUploadRounded } from '@material-ui/icons';
import React, { Component } from 'react';
// import { CircleProgress } from '../../components/Overlay';
// import { linkURL } from '../../js/Domain';
import { base64FromURL, widthHeightRatio } from '../../js/function';
import "./MultiFileUpload.css";
import { ReactTextBtn } from './ReactButton';
import { NoResults } from './ReactError';
import { Files } from '../../js/api';



/**
 * @param {string} id 這張預覽的卡片ID
 * @param {string} name 檔案名稱
 * @param {boolean} isPic 是否是圖片
 * @param {string} base64 檔案的base64
 * @param {float} ratio 寬度除以高度的比例
 * @param {File} file 檔案本體
 * @example
 * [{
 *     id: 每張圖片的ID，沒想法可以先給Date.now()，做出區別就好
 *     name: 檔案名稱,
 *     isPic: 是否是圖片 <boolean>,
 *     src: 檔案的base64 或是路徑
 *     ratio: 寬度除以高度的比例
 *     file: 檔案本體 
 * }]
 */
class MultiFileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data.map(item => ({ ...item, type: item.isPic === undefined ? "loadding" : "ready" })),
            focusCardId: "",
            isPicArr: ["jpg", "jpeg", "png"],
            max: props.max !== undefined && typeof props.max === "number" ? props.max : null,
            maxSize: props.maxSize === undefined ? null : props.maxSize, // 檔案大小限制
        }
    }

    componentDidMount() {
        this.refreshData();
    }

    getState = async (name) => this.state[name];

    /**
     * 重整資料，把不知道是不是圖片的人用URL轉base64，驗證是否試圖檔
     */
    refreshData = async () => {
        let { data } = { ...this.state };
        let arr = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let { isPic, ratio } = { ...item };
            if (isPic === undefined) {
                await base64FromURL(item.src)
                    .then(async base64 => {
                        // 判斷檔案類型
                        this.state.isPicArr.forEach(elem => {
                            if (base64.slice(0, base64.indexOf("base64")).indexOf(elem) !== -1) isPic = true;
                        });

                        if (ratio === undefined) ratio = isPic ? await widthHeightRatio(base64) : 1;
                        arr.push({
                            type: "ready",
                            id: item.id,
                            name: item.name,
                            src: item.src,
                            isPic: isPic,
                            ratio: ratio,
                            file: item.file,
                            path: item.path
                        });
                    }).catch(rse => {
                        arr.push({
                            type: "ready",
                            id: item.id,
                            name: item.name,
                            src: item.src,
                            isPic: false,
                            ratio: 1,
                            file: item.file,
                            path: item.path
                        });
                    });
            } else {
                arr.push(item);
            }
        }
        this.setState(() => ({
            data: arr
        }), async () => {
            await this.checkLoadding();
        });
    }

    setNewState = async (name, data) => {
        let obj = this.state;
        obj[name] = data;
        this.setState(() => obj, async () => {
            await this.refreshData();
        });
    }

    /**
     * 檢查有沒有還在loadding
     */
    checkLoadding = async () => {
        for (let i = 0; i < this.state.data.length; i++) {
            let item = this.state.data[i];
            let { type } = { ...item };
            if (type === "loadding") {
                await this.updateReadFile(item);
            }
        }
    }

    /**
     * 透過修改state 的data時，需要重新讀取檔案的時候用
     */
    updateReadFile = async (item) => {
        let { id, file } = { ...item };
        await this.readFile({
            target: {
                value: "",
                files: [file]
            }
        }, id, true)
    }

    /**
     * 新建的onchange
     * @param {*} e 
     * @param {*} id 
     * @returns 
     */
    readFile = async (e, id = null, isUpdateFile = false) => {
        let target = e.target;
        let files = target.files;
        if (files.length > 0) {
            let file_id = id === null ? Date.now() : id;
            let file = files[0];

            // 檔案大小限制
            if (this.state.maxSize !== null && this.state.maxSize < file.size) {
                if (this.props.responseMessage) this.props.responseMessage({ message: "檔案大小限制" + (this.state.maxSize / 1024 / 1024) + " MB", success: false, data: null });
                else {
                    alert("檔案大小限制" + (this.state.maxSize / 1024 / 1024) + " MB");
                }
                target.value = "";
                return;
            }

            let arr = [...this.state.data];

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                let base64 = reader.result;
                // 如果是圖片，就變成base64預覽
                let isPic = false;
                this.state.isPicArr
                    .forEach(elem => {
                        if (base64.slice(0, base64.indexOf("base64")).indexOf(elem) !== -1)
                            isPic = true
                    });
                // 取得圖片的寬高比
                let ratio = isPic ? await widthHeightRatio(base64) : 1;
                // 成功之後setState把base64 放進去
                arr = arr.map(item => {
                    if (item.id === file_id) {
                        return {
                            ...item,
                            type: isUpdateFile ? "ready" : "new",
                            src: base64,
                            isPic: isPic,
                            ratio: ratio
                        };
                    } else return { ...item };
                })
                this.setState({ data: arr });
            };
            reader.onerror = error => {
                console.log("UPLOAD FILE ERROR: ", error);
                // 如果出錯就連loadding 都不要了
                if (this.props.responseMessage) this.props.responseMessage({ message: "檔案讀取失敗", success: false, data: null });
                else {
                    alert("檔案讀取失敗");
                }
                this.setState({ data: arr.filter(item => item.id !== file_id) });
            };

            // 如果arr裡面已經有這個人了就不要另外加入去等img onload
            // 檔案名稱重複也不要
            if (!arr.some(item => item.id === file_id || item.name === file.name)) {
                arr.push({
                    id: file_id,
                    type: "loadding",
                    isPic: false,
                    src: "",
                    name: file.name,
                    ratio: 1,
                    file: file
                });
            } else {
                if (this.props.responseMessage) this.props.responseMessage({ message: "檔名重複，請重新命名", success: false, data: null });
                else {
                    alert("檔名重複，請重新命名");
                }
                target.value = "";
                return;
            }

            this.setState(() => ({
                data: arr
            }), () => {
                target.value = "";
            });
        }
    }

    /**
     * 刪除點擊事件
     * @param {*} id 
     */
    deleteHandleClick = async (id) => {
        let arr = this.state.data.filter(item => item.id !== id);
        this.setState({
            data: arr
        });
    }

    /**
     * 預覽點擊事件
     * @param {*} id 
     */
    previewHandleClick = (e, item) => {
        e.stopPropagation();
        // 在還沒有 path 的時候，path 傳入的是src 用base64預覽
        let path = item.path === "" || item.path === undefined ? item.src : item.path;
        if (path.indexOf("data:application/pdf;base64,") !== -1) {
            // PDF 預覽
            const base64Data = path.replace(/^data:application\/pdf;base64,/, '');
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
        } else if (path.indexOf("data:image/") !== -1) {
            // 圖片預覽
            const base64Data = path.replace(/^data:image\/\w+;base64,/, '');
            const blob = this.base64ToBlob(base64Data, 'image/png');
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
        } else {
            window.open(path);
        };
    };

    /**
     * base64 轉 blob
     * @param {string} base64Data - 包含 base64 的編碼字串
     * @param {string} contentType - Blob 對象包含的內容類型
     * @returns {Blob}
    */
    base64ToBlob = (base64Data, contentType) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    };

    render() {
        let modeArr = typeof this.props.mode === "string" ? [this.props.mode] : this.props.mode;
        const isEditable = !modeArr.some(item => item === "read"); // 只要有read就不能編輯
        const hasDelete = isEditable ? modeArr.some(item => item === "delete") : false;
        const hasPreview = isEditable ? modeArr.some(item => item === "preview") : false;
        const hasUpload = isEditable ? modeArr.some(item => item === "upload") : false;
        return (
            <Box display="flex" flexWrap="wrap">
                {this.state.data.map((item, index) => {
                    if (item.type === "loadding") {
                        return (<Grid item lg={3} md={4} xs={12} key={item.id}>
                            <Card style={{ boxShadow: "none", padding: "0.5rem", background: "none" }}>
                                <CardActionArea className='upload_file_btn'>
                                    <CardMedia className='upload_file_upload'
                                        children={<CircularProgress />}
                                        title="upload files"
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>);
                    } else {
                        // 讀取完畢
                        return (<Grid item lg={3} md={4} xs={12} key={item.id}>
                            <Card className={'upload_file_card' + (isEditable ? "" : " noHover")}
                                style={{ boxShadow: "none", padding: "0.5rem", background: "none" }}>
                                <CardMedia
                                    className='upload_file_preview'
                                    children={<>
                                        {isEditable ? // 如果可以編輯(沒有read)，但可以刪除或預覽
                                            hasPreview || hasDelete ? // 如果有預覽或刪除
                                                <div className={'upload_file_edit' + (this.state.focusCardId === item.id ? " show" : "")} >
                                                    {hasDelete ?
                                                        <ReactTextBtn
                                                            style={{ margin: "5px" }}
                                                            variant="contained"
                                                            click={() => { this.deleteHandleClick(item.id) }}
                                                            text="刪除"
                                                        /> : null}
                                                    {hasPreview ?
                                                        <ReactTextBtn
                                                            style={{ margin: "5px" }}
                                                            color="secondary"
                                                            variant="contained"
                                                            disabled={item.path === "" && item.path === undefined && item.src.length === 0}
                                                            click={(e) => { this.previewHandleClick(e, item) }}
                                                            text="預覽"
                                                        /> : null}
                                                </div> :
                                                null :
                                            null}
                                        {item.isPic ?
                                            <img src={item.src} style={{ backgroundSize: "contain" }} alt="" /> :
                                            <Typography>無法預覽縮圖</Typography>}
                                    </>}
                                    title={item.name}
                                />
                                <CardContent>
                                    <Typography variant="body2" color="textSecondary" component="p" noWrap={true}
                                        style={{
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        }}>{item.name}</Typography>
                                    <input type="file" id={"upload--file--input--" + index}
                                        style={{ display: "none" }}
                                        onChange={(e) => this.readFile(e, item.id)}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>)
                    }
                })}

                {hasUpload ?
                    <Grid item lg={3} md={4} xs={12}>
                        <Card
                            style={{ boxShadow: "none", padding: "0.5rem", background: "none" }}
                            className={this.state.max !== null && this.state.data.length >= this.state.max ? "noHover" : ""}>
                            {this.state.max !== null && this.state.data.length >= this.state.max ?
                                <CardActionArea className='upload_file_btn'>
                                    <CardMedia className='upload_file_upload'
                                        children={<NoResults title="已達最大上傳數量" />}
                                        title="upload files"
                                    />
                                    <CardContent style={{ display: "none" }} >
                                        <input type="file" id="upload--file--input" style={{ display: "none" }}
                                            onChange={this.readFile}
                                        />
                                    </CardContent>
                                </CardActionArea> :
                                <CardActionArea className='upload_file_btn'
                                    onClick={() => {
                                        document.querySelector("input#upload--file--input[type=file]").click();
                                    }}>
                                    <CardMedia className='upload_file_upload'
                                        children={<>
                                            <CloudUploadRounded fontSize='large' />
                                            <Typography>點擊上傳檔案</Typography>
                                        </>}
                                        title="upload files"
                                    />
                                    <CardContent style={{ display: "none" }} >
                                        <input type="file" id="upload--file--input" style={{ display: "none" }}
                                            onChange={this.readFile}
                                            // 接受的檔案類型: 圖片、pdf、excel、word、ppt
                                            accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                                        />
                                    </CardContent>
                                </CardActionArea>}
                        </Card>
                    </Grid> :
                    null}
            </Box >
        );
    }
}



export default MultiFileUpload;